import React, { useEffect, useState } from "react";
import "../../../style/slotbooking.css";
import {
  formatCountdown,
  formatSlotTime,
  getSlotEndTime,
  getSlotTimeline,
  msUntilDelivery,
} from "../../../utils/slotBooking";

interface SlotTimelineProps {
  order: any;
}

const SlotTimeline: React.FC<SlotTimelineProps> = ({ order }) => {
  const [, tick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => tick((n) => n + 1), 30000);
    return () => clearInterval(id);
  }, []);

  const steps = getSlotTimeline(order);
  const delivered = steps[steps.length - 1].state === "done";
  const remaining = msUntilDelivery(order?.slotDate, order?.slotTime);

  return (
    <div className="slot-timeline-card">
      <div className="slot-tl-top">
        <div>
          <small>Delivery Target</small>
          <b>{formatSlotTime(getSlotEndTime(order?.slotTime))}</b>
        </div>
        {!delivered && (
          <div>
            <small>Remaining</small>
            <b>{remaining > 0 ? formatCountdown(remaining) : "Due now"}</b>
          </div>
        )}
      </div>

      <ul className="slot-tl">
        {steps.map((st) => (
          <li key={st.label} className={st.state}>
            <span className="dot">
              {st.state === "done" && <i className="bi bi-check-lg"></i>}
            </span>
            <div>
              <strong>{st.label}</strong>
              {st.note && st.state === "done" && <small>{st.note}</small>}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SlotTimeline;
